export default {
    props: {
        columnMenuColumns: {
            type: Boolean,
            kComposite: 'columnMenu.columns'
        }, 
        columnMenuFilterable: {
            type: Boolean,
            kComposite: 'columnMenu.filterable'
        }, 
        columnMenuSortable: {
            type: Boolean,
            kComposite: 'columnMenu.sortable'
        }, 
        columnMenuMessagesColumns: {
            type: String,
            kComposite: 'columnMenu.messages.columns'
        }, 
        columnMenuMessagesFilter: {
            type: String,
            kComposite: 'columnMenu.messages.filter'
        }, 
        columnMenuMessagesSortAscending: {
            type: String,
            kComposite: 'columnMenu.messages.sortAscending'
        }, 
        columnMenuMessagesSortDescending: {
            type: String,
            kComposite: 'columnMenu.messages.sortDescending'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treelist-vue-wrapper/src/KendoTreeList/ColumnMenu.js